import React, { useState } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import { Grid, Typography } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import SbuSelect from "../../_shared/SbuSelect";
import { factoryActions, userActions } from "../../../_redux/actions";
import { authorizationService } from "../../../_services";
import { useDispatch, useSelector } from "react-redux";
import PlantSelect from "../../_shared/PlantSelect";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TableBody from "@material-ui/core/TableBody";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import { alertActions } from "../../../_redux/actions";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const UserFactoryAssign = (props) => {
    const INITIAL_STATE = {
        sbu: '',
        plant: '',
        plantList: [],
        factoryList: [],
        selected: []
    }

    const [userFactoryAssignState, setUserFactoryAssignState] = useState(INITIAL_STATE);
    const sbuListState = useSelector((state: any) => state.factories.sbuList);
    const assignUserFactories = useSelector((state: any) => state.users.assignUserFactories);
    const dispatch = useDispatch();

    React.useEffect(() => {
        // dispatch getAllSbuList action & fetch SBU List
        dispatch(
            factoryActions.getAllSbuList(
                authorizationService.getAuthorizedUser().isAdmin,
                props.user.email,
                () => { },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );
    }, [props.user]);

    // Handle sbu select dropdown change event
    const onSbuChange = (value) => {
        const sbuIndex = sbuListState.data.map(s => s.sbuId).indexOf(value)
        setUserFactoryAssignState({
            ...userFactoryAssignState,
            sbu: value,
            plantList: sbuListState.data[sbuIndex].plants
        })
    }

    // Handle plant select dropdown change event
    const onPlantChange = (value) => {
        const plantIndex = userFactoryAssignState.plantList.map(p => p.id).indexOf(value);
        const isAssigned = getIsAssigned(userFactoryAssignState.plantList[plantIndex].factories);
        setUserFactoryAssignState({
            ...userFactoryAssignState,
            plant: value,
            factoryList: userFactoryAssignState.plantList[plantIndex].factories,
            selected: isAssigned
        })
    }

    // check factor isAssigned
    const getIsAssigned = (data) => {
        let newSelected: number[] = [];
        data.forEach(row => {
            if (row.isAssigned) newSelected.push(row.id)
        })
        return newSelected;
    }

    // Handle select factory (row) checkbox event
    const selectFactory = (event, id) => {
        const selectedIndex = userFactoryAssignState.selected.indexOf(id);
        let newSelected: number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(userFactoryAssignState.selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(userFactoryAssignState.selected.slice(1));
        } else if (selectedIndex === userFactoryAssignState.selected.length - 1) {
            newSelected = newSelected.concat(userFactoryAssignState.selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                userFactoryAssignState.selected.slice(0, selectedIndex),
                userFactoryAssignState.selected.slice(selectedIndex + 1),
            );
        }
        setUserFactoryAssignState({
            ...userFactoryAssignState,
            selected: newSelected
        })
    }

    // Handle select all factories checkbox change
    const selectAllFactories = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = userFactoryAssignState.factoryList.map((n) => n.id);
            setUserFactoryAssignState({
                ...userFactoryAssignState,
                selected: newSelecteds
            });
            return;
        }
        setUserFactoryAssignState({
            ...userFactoryAssignState,
            selected: []
        });
    }

    // detect factory isSelected
    const isSelected = (id: number): boolean => userFactoryAssignState.selected.indexOf(id) !== -1;

    return (
        <div>
            <DialogContent>
                <Typography className="uppercase fontSizePrimary">Please select SBU & Plant to load factories list.</Typography>
                <Typography className="uppercase fontSizePrimary mtM">
                    <Box color="error.main" fontSize={14}>{assignUserFactories.isError ? assignUserFactories.error.message : null}</Box>
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="SBU" variant="block">
                            <SbuSelect
                                sbus={sbuListState.data}
                                selectedValue={userFactoryAssignState.sbu}
                                onSbuChange={onSbuChange}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Plant" variant="block">
                            <PlantSelect
                                plants={userFactoryAssignState.plantList}
                                selectedValue={userFactoryAssignState.plant}
                                onPlantChange={onPlantChange}
                            />
                        </FormControlWrapper>
                    </Grid>
                </Grid>
                <TableContainer component={Paper} className="mtM">
                    <Table aria-label="simple table" size="small" className={'appTable'} >
                        {userFactoryAssignState.factoryList.length > 0 ? (
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={userFactoryAssignState.selected.length > 0 && userFactoryAssignState.selected.length < userFactoryAssignState.factoryList.length}
                                            checked={userFactoryAssignState.factoryList.length > 0 && userFactoryAssignState.selected.length === userFactoryAssignState.factoryList.length}
                                            onChange={selectAllFactories}
                                            color="primary"
                                            inputProps={{ 'aria-label': 'select all' }}
                                        />
                                    </TableCell>
                                    <TableCell component="th">Factory Code</TableCell>
                                    <TableCell component="th">Factory Name</TableCell>
                                </TableRow>
                            </TableHead>
                        ) : null}
                        <TableBody>
                            {userFactoryAssignState.factoryList.map((row, index) => {
                                const isItemSelected = isSelected(row.id);
                                const labelId = `role-checkbox-${index}`;
                                return (
                                    <TableRow key={row.id} onClick={(event) => selectFactory(event, row.id)}>
                                        <TableCell component="td" padding="checkbox">
                                            <Checkbox
                                                checked={isItemSelected}
                                                color="primary"
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </TableCell>
                                        <TableCell component="td">{row.code}</TableCell>
                                        <TableCell>{row.name}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

            </DialogContent>
            <DialogActions>
                <Button variant="contained"
                    color="secondary"
                    onClick={() => props.assignFactory(userFactoryAssignState.selected, userFactoryAssignState.plant)}
                    disabled={(!userFactoryAssignState.plant || !userFactoryAssignState.sbu)}
                >
                    Assign
                </Button>
            </DialogActions>
        </div>
    );
}

UserFactoryAssign.propTypes = {
    user: PropTypes.any,
    onClose: PropTypes.func,
    assignFactory: PropTypes.func,
}

export default UserFactoryAssign;
